import { render, staticRenderFns } from "./EcnSlideMobile.vue?vue&type=template&id=1aff0043&scoped=true"
import script from "./EcnSlideMobile.vue?vue&type=script&lang=js"
export * from "./EcnSlideMobile.vue?vue&type=script&lang=js"
import style0 from "./EcnSlideMobile.vue?vue&type=style&index=0&id=1aff0043&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aff0043",
  null
  
)

export default component.exports